import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { environment } from 'src/environments/environment';

/**
 * Enumération pour ne pas se planter dans les noms de requetage des propriétés.
 */
export enum FILTER_NAME {
  API_NAME = 'apiName',
  ROUTE_URL = 'routeUrl',
  DISTRIB_ID = 'distribID',
  APP_CODE = 'appCode',
}

/**
 * Récupération de l'application en passant une valeur (context, url) et le paramètre suivant l'enum servant de filtre.
 * @param value
 * @param filter
 * @returns
 */
export function searchApplication(value: string, filter: FILTER_NAME): any {
  let application = undefined;
  Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
    if (app[filter] === value) {
      application = app;
    } else if (app['children'] != null) {
      app['children'].forEach(child => {
        if (child[filter] === value) {
          application = child;
        }
      });
    }
  });
  return application;
}

export function getAppUrl(distribId: string): string {
  let route: string = undefined;

  Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
    if (app.distribID === distribId) {
      route = app.routeUrl;
    } else if (app['children']) {
      app['children'].forEach(child => {
        if (child['distribID'] === distribId) {
          route = (environment.vendor ? app.routeUrl + '/' : '') + child['routeUrl'];
        }
      });
    }
  });

  return route;
}

export function isKitchen(distribId: string): boolean {
  return distribId == CONFIG_CONTEXT.KITCHEN || distribId == environment.byMe.kitchen.distribID;
}

export function isStorage(distribId: string): boolean {
  return distribId == CONFIG_CONTEXT.STORAGE || distribId == environment.byMe.storage.distribID;
}

export function isBathroom(distribId: string): boolean {
  return distribId == CONFIG_CONTEXT.BATHROOM || distribId == environment.byMe.bathroom.distribID;
}

export function getAppGtmRef(distribId: string): string {
  let gtmRef: string = undefined;

  if (isKitchen(distribId)) {
    return 'cuisine';
  } else if (isStorage(distribId)) {
    return 'rangements';
  } else if (isBathroom(distribId)) {
    return 'salle-de-bain';
  }

  Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
    if (app.distribID === distribId) {
      gtmRef = app.gtmRef;
    } else if (app['children']) {
      app['children'].forEach(child => {
        if (child['distribID'] === distribId) {
          gtmRef = app.gtmRef;
        }
      });
    }
  });

  return gtmRef;
}

export function getHbmTotalSteps(distribId: string): number {
  if (isKitchen(distribId)) {
    return 11;
  } else if (isStorage(distribId)) {
    return 10;
  } else if (isBathroom(distribId)) {
    return 4;
  }

  return 0;
}

export function getHbmAppName(distribId: string): string {
  if (isKitchen(distribId)) {
    return 'Cuisine';
  } else if (isStorage(distribId)) {
    return 'Rangements';
  } else if (isBathroom(distribId)) {
    return 'Salle de bain';
  }

  return '';
}

/**
 * Récupération du context nécessaire au lancement d'une config.
 * @param route
 * @returns
 */
export function getContext(route: string) {
  // Test du dernier context.
  let _route_context = _defineRouteContext(route);
  // Vérification du context
  let app = searchApplication(_route_context, FILTER_NAME.ROUTE_URL);
  if (!app) {
    return undefined;
  }
  return app.distribID;
}

/**
 * Récupération des contexts enfants pour le bon affichage de la sélection du configurateur
 * @param route
 * @returns
 */
export function getChildrenApplications(route: string) {
  let parentContext = getContext(route);
  let children: any;
  Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
    if (app.distribID == parentContext) children = app['children'];
  });
  return children;
}

/**
 * Récupération des contexts enfants pour le bon affichage de la sélection du configurateur
 * @param parentContext
 * @returns
 */
export function getChildrenApplicationsFromParentContext(parentContext: string) {
  let children: any;
  Object.entries(environment.configurators2d.applications).forEach(([, app]) => {
    if (app.distribID == parentContext) children = app['children'];
  });
  return children;
}

export function getParentApplication(route: string) {
  let parentContext = getContext(route);
  return searchApplication(parentContext, FILTER_NAME.DISTRIB_ID);
}

export function getParentApplicationFromContext(context: string) {
  return searchApplication(context, FILTER_NAME.DISTRIB_ID);
}

/**
 * Fonction récupérant le dernier context de la route != configuration
 * @param route_array
 * @returns
 */
function _defineRouteContext(route: string): string {
  // Utilisation de l'url pour récupérer les contexts.
  const route_array = route.split('/');

  if (route_array.length < 2) {
    return undefined;
  }

  const lastElement = route_array[route_array.length - 1];
  const secondToLastElement = route_array[route_array.length - 2];

  if (lastElement == 'configuration') {
    return secondToLastElement;
  } else if (route_array.length >= 3 && secondToLastElement == 'open') {
    return route_array[route_array.length - 3];
  }

  return lastElement;
}
